// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Statistics utils required for calculator.
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
/**
 * Calculate variance of numbers passed in input array.
 * @param {number[]} data Array of numbers to calculate variance of.
 * @param {object} obj Optional destructured parameters object.
 * @param {boolean} [obj.isSample] Is data a sample of a larger population.
 * @returns {number} Variance of data array.
 */
const variance = (data, { isSample = true } = {}) => {
    const mean = data.reduce((acc, cur) => acc + cur / data.length, 0)
    const sumSquaredError = data.reduce((acc, cur) => {
        const error = cur - mean
        return acc + error * error
    }, 0)

    return sumSquaredError / (isSample ? data.length - 1 : data.length)
}

// @@exports
export { variance }
